"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionEditorIssue = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward/useCallforward"));
const react_markdown_1 = require("@opsbase/react-markdown");
const react_simple_reducer_1 = require("@opsbase/react-simple-reducer");
const useCss_1 = __importDefault(require("@opsbase/web-css/useCss/useCss"));
const useSysLang_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangController/useSysLang"));
const Divider_1 = __importDefault(require("@opsbase/web-layout/Divider"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const FlagPicker_1 = __importDefault(require("@opsbase/web-pickers/FlagPicker"));
const IssueTypePicker_1 = __importDefault(require("@opsbase/web-pickers/IssueTypePicker"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur"));
const Checkbox_1 = __importDefault(require("@opsbase/web-ui/Checkbox"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const makeMyClasses = title => ({
    textField: {
        '& fieldset': {
            borderColor: !!title ? '' : `${lib_palette_1.default.error} !important`,
            borderWidth: !!title ? 1 : 2,
        },
    },
});
exports.QuestionEditorIssue = react_1.default.memo((props) => {
    var _a;
    const { config, onChange, disabled } = props;
    const myCss = (0, useCss_1.default)(makeMyClasses, [config.title]);
    const { isAlt, language } = (0, useSysLang_1.default)();
    const [state, dispatch] = (0, react_1.useReducer)(react_simple_reducer_1.reducer, config);
    const lTitle = isAlt ? ((_a = state.titleAlt) === null || _a === void 0 ? void 0 : _a[language]) || state.title : state.title;
    const onChangeProxy = (0, react_1.useCallback)(c => onChange === null || onChange === void 0 ? void 0 : onChange(c), [onChange]);
    const throttledOnChange = (0, react_1.useMemo)(() => (0, throttle_1.default)(onChangeProxy, 1000), [onChangeProxy]);
    (0, react_1.useEffect)(() => {
        if (config !== state)
            throttledOnChange(state);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]);
    const handleChange = (0, useCallforward_1.default)(field => value => dispatch({ field, value }), []);
    const handleChangeNumber = (0, useCallforward_1.default)(field => value => dispatch({ field, value: parseInt(value) }), []);
    const handleChangeTitle = (0, react_1.useCallback)(value => {
        let updateTitle = true;
        if (isAlt) {
            dispatch({ field: 'titleAlt', value: Object.assign(Object.assign({}, state.titleAlt), { [language]: value }) });
            updateTitle = !state.title;
        }
        if (updateTitle) {
            dispatch({ field: 'title', value });
        }
    }, [isAlt, language, state]);
    return (react_1.default.createElement(Vertical_1.default, { gutter: true, paddingY: true },
        react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('questiontype-issue-blurb')),
        react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { disabled: disabled, label: lib_i18n_1.default.t('issue-title-placeholder'), fullWidth: true, value: lTitle, className: myCss.textField, onBlur: handleChangeTitle }),
        react_1.default.createElement(IssueTypePicker_1.default, { disabled: disabled, value: state.type, onChange: handleChange('type'), label: lib_i18n_1.default.t('issue-type'), fullWidth: true }),
        react_1.default.createElement(FlagPicker_1.default, { disabled: disabled, value: state.flag, onChange: handleChange('flag'), label: lib_i18n_1.default.t('flag'), fullWidth: true }),
        react_1.default.createElement("div", { style: { marginBottom: 10 } },
            react_1.default.createElement(Checkbox_1.default, { disabled: disabled, checked: state.hasDeadline, color: lib_palette_1.default.secondary, onChange: handleChange('hasDeadline'), label: (0, react_markdown_1.markdown)(lib_i18n_1.default.t('questiontype-issue-deadline')) }),
            state.hasDeadline ? (react_1.default.createElement(Pane_1.default, { padding: "0 5" },
                react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { disabled: disabled, fullWidth: true, InputProps: {
                        endAdornment: 'days',
                    }, type: "number", value: state.deadlineInDays, onBlur: handleChangeNumber('deadlineInDays'), placeholder: lib_i18n_1.default.t('deadline') }))) : null),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(Checkbox_1.default, { checked: state.allowOverrides, disabled: disabled, color: lib_palette_1.default.secondary, onChange: handleChange('allowOverrides'), label: (0, react_markdown_1.markdown)(lib_i18n_1.default.t('questiontype-issue-override')) })));
});
exports.default = exports.QuestionEditorIssue;
